export function initPasswordToggles() {
  const inputs = document.querySelectorAll('input[type="password"]');

  inputs.forEach((input) => {
    const toggle = input.parentElement?.querySelector('.input-group__passwordToggle');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      toggle.classList.toggle('show');
      input.type = toggle.classList.contains('show') ? 'text' : 'password';

      if (Shopify.locale === 'ru') {
        toggle.setAttribute(
          'aria-label',
          toggle.classList.contains('show') ? 'Скрыть пароль' : 'Показать пароль'
        );
      } else {
        toggle.setAttribute(
          'aria-label',
          toggle.classList.contains('show') ? 'Приховати пароль' : 'Показати пароль'
        );
      }
    });
  });
}